//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { ElectricalVehicleChargingStationLargeSVG } from './svg'

interface ElectricalVehicleChargingStationLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const ElectricalVehicleChargingStationLargeIcon: React.FC<ElectricalVehicleChargingStationLargeIconProps> = forwardRef<
  ElectricalVehicleChargingStationLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={ElectricalVehicleChargingStationLargeSVG}
    sx={sx}
  />
))
